import type { CaseResultRecord } from '@/lib/blocks/collection/records';
import type { PracticeArea } from '@/types/shared';

export const TEMPLATE_PREVIEW_CASE_RESULTS: CaseResultRecord[] = [
  {
    id: 'preview-case-result-1',
    title: '$3.2M Settlement in Medical Malpractice Case',
    summary: 'Successfully secured a substantial settlement after surgical complications.',
    path: 'case-results/medical-malpractice-settlement',
    attorneys: [{ name: 'Sarah Williams' }],
    courts: [{ id: 'preview-court-1', name: 'Superior Court' }],
    practiceAreas: [{ id: 'preview-practice-area-1', name: 'Medical Malpractice' }],
  },
  {
    id: 'preview-case-result-2',
    title: 'Complete Dismissal in Criminal Defense',
    summary: 'All charges dismissed after presenting compelling evidence.',
    path: 'case-results/criminal-defense-dismissal',
    attorneys: [{ name: 'David Brown' }],
    courts: [{ id: 'preview-court-2', name: 'District Court' }],
    practiceAreas: [{ id: 'preview-practice-area-2', name: 'Criminal Defense' }],
  },
  {
    id: 'preview-case-result-3',
    title: 'Favorable Outcome in Business Dispute',
    summary: 'Resolved a complex commercial disagreement through focused negotiation.',
    path: 'case-results/business-dispute-outcome',
    attorneys: [{ name: 'Sarah Williams' }],
    courts: [{ id: 'preview-court-3', name: 'Circuit Court' }],
    practiceAreas: [{ id: 'preview-practice-area-3', name: 'Business Law' }],
  },
  {
    id: 'preview-case-result-4',
    title: '$850K Recovery After Motor Vehicle Collision',
    summary: 'Recovered compensation for a client injured in a serious roadway crash.',
    path: 'case-results/motor-vehicle-collision-recovery',
    attorneys: [{ name: 'Maria Garcia' }],
    courts: [{ id: 'preview-court-4', name: 'County Court' }],
    practiceAreas: [{ id: 'preview-practice-area-4', name: 'Personal Injury' }],
  },
];

export const TEMPLATE_PREVIEW_PRACTICE_AREAS: PracticeArea[] = [
  { id: 'preview-practice-area-1', name: 'Medical Malpractice' },
  { id: 'preview-practice-area-2', name: 'Criminal Defense' },
  { id: 'preview-practice-area-3', name: 'Business Law' },
  { id: 'preview-practice-area-4', name: 'Personal Injury' },
];
